import React from "react";
import {
  Paper,
  Typography,
  Box,
  List,
  Chip,
  Divider,
  Card,
  CardContent,
} from "@mui/material";
import SimpleBarReact from "simplebar-react";
import "simplebar-react/dist/simplebar.min.css";
import PropTypes from "prop-types";
import LocationOnIcon from "@mui/icons-material/LocationOn";

// Mapa de colores para los estados
const statusColors = {
  Cancelado: "#b10e1a",
  Finalizado: "#4d4d4d",
  Fallido: "#4a2c04",
  Asignado: "#1f7362",
  "Pre-Asignado": "#0c27a0",
  Programado: "#6c06b5",
  Enterado: "#0c5b07",
  Iniciado: "#fa7114",
  Aceptado: "#088A08",
  "En Camino": "#FFBF00",
  Esperando: "#a44706",
  default: "#b0b500",
};

const ZonasColumn = ({ traslados = [] }) => {
  // Agrupar traslados por zona_paciente
  const zonas = traslados.reduce((acc, traslado) => {
    const zona = traslado.zona_paciente || "Sin Zona";
    if (!acc[zona]) {
      acc[zona] = { total: 0, statuses: {} };
    }
    acc[zona].total += 1;
    const status = traslado.status;
    if (!acc[zona].statuses[status]) {
      acc[zona].statuses[status] = 0;
    }
    acc[zona].statuses[status] += 1;
    return acc;
  }, {});

  // Convertir el objeto de zonas en un array
  const zonasArray = Object.keys(zonas).map((zona) => ({
    nombre: zona,
    total: zonas[zona].total,
    statuses: zonas[zona].statuses,
  }));

  return (
    <Paper
      elevation={2}
      sx={{
        padding: 0,
        backgroundColor: "#ffffff",
        borderRadius: "12px",
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.08)",
        display: "flex",
        flexDirection: "column",
        height: "100%",
        overflow: "hidden",
        maxWidth: "100%",
      }}
    >
      <Box
        sx={{
          backgroundColor: "#0a2e5c",
          padding: "16px",
          color: "white",
          position: "sticky",
          top: 0,
          zIndex: 1000,
        }}
      >
        <Typography
          variant="h6"
          sx={{
            fontWeight: "bold",
            display: "flex",
            alignItems: "center",
            gap: "8px",
          }}
        >
          <LocationOnIcon /> Zonas
        </Typography>
      </Box>

      <Box sx={{ padding: "8px 16px" }}>
        <Typography variant="subtitle2" color="textSecondary">
          {zonasArray.length} zonas encontradas
        </Typography>
      </Box>

      <Divider />

      <SimpleBarReact
        style={{
          height: "calc(100vh - 240px)",
          minHeight: "520px",
          overflowY: "auto",
          width: "100%",
        }}
      >
        <List
          sx={{
            padding: "8px 12px",
            boxSizing: "border-box",
            width: "100%",
          }}
        >
          {zonasArray.map((zona) => (
            <Card
              key={zona.nombre}
              sx={{
                marginBottom: "12px",
                borderRadius: "12px",
                boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                border: "1px solid rgba(0,0,0,0.08)",
                overflow: "hidden",
                width: "calc(100% - 8px)",
                mx: "auto",
              }}
            >
              <CardContent sx={{ p: 1.5 }}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    mb: 1,
                  }}
                >
                  <Typography
                    variant="subtitle1"
                    sx={{
                      fontWeight: "bold",
                      color: "#1a202c",
                      fontSize: "0.95rem",
                    }}
                  >
                    {zona.nombre}
                  </Typography>
                  <Chip
                    size="small"
                    label={`Total: ${zona.total}`}
                    color="primary"
                    sx={{
                      fontWeight: "bold",
                      backgroundColor: "#0a2e5c",
                      height: "22px",
                    }}
                  />
                </Box>

                <Box sx={{ mt: 1.5 }}>
                  {Object.entries(zona.statuses).map(([status, count]) => (
                    <Box
                      key={status}
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        mb: 1,
                        p: 0.75,
                        borderRadius: "6px",
                        backgroundColor: "rgba(0,0,0,0.02)",
                      }}
                    >
                      <Chip
                        size="small"
                        label={status}
                        sx={{
                          backgroundColor:
                            statusColors[status] || statusColors.default,
                          color: "#fff",
                          fontWeight: "500",
                          minWidth: "110px",
                        }}
                      />
                      <Typography variant="body2" sx={{ fontWeight: "bold" }}>
                        {count}
                      </Typography>
                    </Box>
                  ))}
                </Box>
              </CardContent>
            </Card>
          ))}
        </List>
      </SimpleBarReact>
    </Paper>
  );
};

ZonasColumn.propTypes = {
  traslados: PropTypes.array.isRequired,
};

export default ZonasColumn;
